<template>
  <dropdown placement="bottom" :offset="[0, 17]" class="app-header-global-add-task">
    <dd-icon-button 
      icon="plus" 
      size="medium" 
      title="Add new..." 
    />
    <template #content>
      <div>
        <ul>
          <li v-if="$permissions.isAdminOrOwner" @click.prevent="RouteAssistant.goToCreatePeople($router, $route.params.accountId)"> 
            <router-link :to="RouteAssistant.getCreatePeopleRoute($route.params.accountId)">
              <i class="ddi ddi-people" />
              <span>
                Invite <strong>user</strong>&hellip;
              </span>
            </router-link>
          </li>
          <li v-if="$permissions.isAdminOrOwner && $permissions.isTieredPricingPlan" @click.prevent="RouteAssistant.goToCreateGuests($router, $route.params.accountId)">
            <router-link :to="RouteAssistant.getCreateGuestsRoute($route.params.accountId)">
              <i class="ddi ddi-people" />
              <span>
                Invite <strong>guest</strong>&hellip;
              </span>
            </router-link>
          </li>
          <li v-if="$permissions.isNotGuest" @click.prevent="RouteAssistant.goToGlobalCreateTask($router, $route.params.accountId)"> 
            <router-link :to="RouteAssistant.getGlobalCreateTaskRoute($route.params.accountId)">
              <i class="ddi ddi-task" />
              <span>
                New <strong>task</strong>&hellip;
              </span>
            </router-link>
          </li>
          <li v-if="$permissions.isAdminOrOwner && $screen.isDesktop($mq)" @click.prevent="RouteAssistant.goToCreateProject($router, $route.params.accountId)"> 
            <router-link :to="RouteAssistant.getCreateProjectRoute($route.params.accountId)">
              <i class="ddi ddi-project" />
              <span>
                New <strong>project</strong>&hellip;
              </span>
            </router-link>
          </li>
          <li v-if="$permissions.isAdminOrOwner && $screen.isDesktop($mq)" @click.prevent="RouteAssistant.goToCreateMailbox($router, $route.params.accountId)"> 
            <router-link :to="RouteAssistant.getCreateMailboxRoute($route.params.accountId)">
              <i class="ddi ddi-mailbox" />
              <span>
                New <strong>mailbox</strong>&hellip;
              </span>
            </router-link>
          </li>
        </ul>
      </div>
    </template>
  </dropdown>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import RouteAssistant from '@/helpers/route-assistant'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default defineComponent({
  name: 'AppHeaderAddGlobal',

  data() {
    return {
      RouteAssistant,
    }
  },
})
</script>

<style lang="scss">
.app-header-global-add-task {
  .dropdown__popper {
    max-height: 420px;

    @include media-breakpoint-down(md) {
      max-height: 380px;
    }
  }
}
</style>
